import { visit as a, SKIP as h } from "unist-util-visit";
import { u as c } from "unist-builder";
import { getBaseUrl as u } from "@nextcloud/router";
const k = /(\s|^)(https?:\/\/)([-A-Z0-9+_.]+(?::[0-9]+)?(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*)(\s|$)/ig, f = /(\s|\(|^)((https?:\/\/)([-A-Z0-9+_.]+[-A-Z0-9]+(?::[0-9]+)?(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*))(?=\s|\)|$)/ig, g = {
  name: "NcLink",
  props: {
    href: {
      type: String,
      required: !0
    }
  },
  render(r) {
    return r("a", {
      attrs: {
        href: this.href,
        rel: "noopener noreferrer",
        target: "_blank",
        class: "rich-text--external-link"
      }
    }, [this.href.trim()]);
  }
}, _ = function({ autolink: r, useMarkdown: t, useExtendedMarkdown: n }) {
  return function(i) {
    n || !t || !r || a(i, (o) => o.type === "text", (o, e, p) => {
      let l = m(o.value);
      return l = l.map((s) => typeof s == "string" ? c("text", s) : c("link", {
        url: s.props.href
      }, [c("text", s.props.href)])).filter((s) => s), p.children.splice(e, 1, ...l.flat()), [h, e + l.flat().length];
    });
  };
}, m = (r) => {
  let t = f.exec(r);
  const n = [];
  let i = 0;
  for (; t !== null; ) {
    let e = t[2], p, l = r.substring(i, t.index + t[1].length);
    e[0] === " " && (l += e[0], e = e.substring(1).trim());
    const s = e[e.length - 1];
    (s === "." || s === "," || s === ";" || t[0][0] === "(" && s === ")") && (e = e.substring(0, e.length - 1), p = s), n.push(l), n.push({ component: g, props: { href: e } }), p && n.push(p), i = t.index + t[0].length, t = f.exec(r);
  }
  n.push(r.substring(i));
  const o = n.map((e) => typeof e == "string" ? e : e.props.href).join("");
  return r === o ? n : (console.error("Failed to reassemble the chunked text: " + r), r);
}, R = (r, t) => {
  if (!r || !t.includes(u()))
    return null;
  const n = r.getRoutes().map((i) => new RegExp(i.regex.source.slice(1, -1), i.regex.flags));
  for (const i of n) {
    const o = t.search(i);
    if (o !== -1)
      return t.slice(o);
  }
};
export {
  k as U,
  R as g,
  m as p,
  _ as r
};
